<script async setup lang="ts">
import type { IAccoItem } from '@/composables/interfaces/apiInterfaces'
import AccoItem from '../accoitem/AccoItem.vue'
import MobileAccoItem from '../accoitem/AccoItemMobil.vue'
import AccoItemPlaceholder from '../accoitem/AccoItemPlaceholder.vue'

const props = defineProps<{
  results: IAccoItem[]
  showPlaceholder: boolean
}>()

const placeholders = Array(10)
</script>

<template>
  <div class="grid grid-cols-1 justify-items-center gap-6 pt-6 md:grid-cols-1">
    <template v-if="showPlaceholder">
      <AccoItemPlaceholder v-for="(_, index) in placeholders" :key="index" />
    </template>
    <template v-else>
      <AccoItem class="hidden md:block" :item="item" v-for="item of props.results" :key="item.companyId" />
      <MobileAccoItem class="md:hidden" :item="item" v-for="item of props.results" :key="item.companyId" />
    </template>
  </div>
</template>
